import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import "./webdm.css";
import Chatbot from "../utils/Chatbot";
import AlertComponent from "../Components/AlertComponent";
import HomeComponent from "../Components/HomeComponent";
import { useAuth, useLogout } from "../hooks/auth";
import Sidebar from "../Components/Sidebar";
import LetterAvatars from "../Components/Avatar";
import BadgeNotification from "../Components/BadgeNotification";
import IntegrationIcons from "../Components/IntegrationIcons";



const upperBar =
  "url('../img/grain-texture-dark.png')";
/* const themeColorBox = 'linear-gradient(to bottom, #0F002A, #0F013A)'; */

const drawerWidth = 240;

let currentPage = "";

function Home() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { logout, toast, setToast } = useLogout();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const { user } = useAuth();

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* Topbar */}


      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar className="topbar" sx={{ paddingTop: '8px', paddingBottom: '8px' }}>
          
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            sx={{ color: "white", textAlign: "center", margin: "auto" }}
            variant="h6"
            noWrap
            component="div"
            className="dashboard-typography"
          >
            Dashboard {currentPage}
          </Typography>
          
          <IntegrationIcons />
          <LetterAvatars />
          <BadgeNotification />
        </Toolbar>

        <HomeComponent />
        <Chatbot />
      </AppBar>

      {/* Sidebar */}
      <Sidebar
        logout={logout}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      {/* alert message component */}

      <AlertComponent alert={toast} setOpenAlert={setToast} />
    </Box>
  );
}

export default Home;
